import { useState, type FormEvent } from 'react'

import { api, ErrorApi } from '../api'
import { leerNumero } from '../formato'
import { DATO_TECNICO, leerDatoTecnico, type TipoEquipo } from './datoTecnicoItem'

interface Props {
  alCrear: () => void
}

/**
 * Alta de un item propio: un panel, un inversor o una batería, con su dato técnico, su costo
 * (sin IVA ni utilidad) y si grava IVA. Sale en la lista de su tipo al elegir los equipos a
 * mano, y el cálculo sale de su dato técnico (los kWp y, con ellos, la instalación).
 */
export function NuevoItemCatalogo({ alCrear }: Props) {
  const [nombre, setNombre] = useState('')
  const [tipo, setTipo] = useState<TipoEquipo | ''>('')
  const [dato, setDato] = useState('')
  const [costo, setCosto] = useState('')
  const [gravaIva, setGravaIva] = useState(false)
  const [error, setError] = useState('')
  const [ocupado, setOcupado] = useState(false)

  const guardar = async (e: FormEvent) => {
    e.preventDefault()
    const n = leerNumero(costo)
    if (!nombre.trim()) return setError('Escribe el nombre del item.')
    if (!tipo) return setError('Elige si es un panel, un inversor o una batería.')
    const tecnico = leerDatoTecnico(tipo, dato)
    if (typeof tecnico === 'string') return setError(tecnico)
    if (n === null || Number.isNaN(n) || n < 0) return setError('El costo tiene que ser un valor en USD, por ejemplo 120,50.')
    setOcupado(true)
    try {
      await api.crearItem({ nombre: nombre.trim(), costo: n, grava_iva: gravaIva, tipo, ...tecnico })
      setNombre('')
      setCosto('')
      setDato('')
      setError('')
      alCrear()
    } catch (err) {
      setError(err instanceof ErrorApi ? err.message : 'No se pudo guardar.')
    } finally {
      setOcupado(false)
    }
  }

  return (
    <form className="tarjeta nuevo-item" onSubmit={guardar}>
      <label>
        Nombre del item
        <input value={nombre} onChange={(e) => setNombre(e.target.value)} maxLength={160} placeholder="Ej.: Panel Jinko 620 W" />
      </label>
      <label>
        Tipo
        <select value={tipo} onChange={(e) => setTipo(e.target.value as TipoEquipo | '')}>
          <option value="">Elige…</option>
          <option value="panel">Panel</option>
          <option value="inversor">Inversor</option>
          <option value="bateria">Batería</option>
        </select>
      </label>
      {tipo && (
        <label>
          {DATO_TECNICO[tipo].etiqueta}
          <input value={dato} onChange={(e) => setDato(e.target.value)} inputMode="decimal" placeholder={DATO_TECNICO[tipo].ejemplo} />
        </label>
      )}
      <label>
        Costo (USD)
        <input value={costo} onChange={(e) => setCosto(e.target.value)} inputMode="decimal" placeholder="Sin IVA ni utilidad" />
      </label>
      <label>
        IVA
        <select value={gravaIva ? 'si' : 'no'} onChange={(e) => setGravaIva(e.target.value === 'si')}>
          <option value="no">No grava IVA (0 %)</option>
          <option value="si">Grava IVA (15 %)</option>
        </select>
      </label>
      <button className="primario" disabled={ocupado}>
        {ocupado ? 'Guardando…' : 'Agregar al catálogo'}
      </button>
      {tipo && <small className="ayuda">Saldrá en la lista de {tipo === 'panel' ? 'paneles' : tipo === 'inversor' ? 'inversores' : 'baterías'} de la cotización, junto a los demás.</small>}
      {error && <p className="error">{error}</p>}
    </form>
  )
}
